(function () {
  'use strict';

  /*
    Headboard size -> gallery image (alt-tag matching).

    When a customer selects a headboard size, this shows the matching product
    image in the main gallery. The match is done by alt tag, the same way color
    swatches work: the selected option value (e.g. '60" Inches Tall Headboard')
    is handleized to '60-inches-tall-headboard' and compared to each gallery
    thumbnail's alt text. Tag your headboard images with an alt such as
    '60-inches-tall-headboard' (or '60 Inches Tall Headboard') so they match.

    This is intentionally additive: it does not modify the theme's gallery
    controller. Selecting a color/size option restores the normal gallery view.
  */

  function handleize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function getSelectedHeadboardValue() {
    var btn =
      document.querySelector('.headboard-opt.is-selected') ||
      document.querySelector('.headboard-opt[aria-pressed="true"]');
    return btn ? (btn.getAttribute('data-option-value') || '') : '';
  }

  function findHeadboardThumb(sizeValue) {
    if (!sizeValue) return null;
    var target = handleize(sizeValue);
    var sizeNumber = (String(sizeValue).match(/\d+/) || [])[0] || '';
    var thumbs = document.querySelectorAll('[data-gallery-thumb]:not([data-static-thumb])');

    for (var i = 0; i < thumbs.length; i++) {
      var thumb = thumbs[i];
      var alt = thumb.getAttribute('data-image-alt') || '';
      if (!alt && thumb.querySelector('img')) {
        alt = thumb.querySelector('img').getAttribute('alt') || '';
      }
      var handle = handleize(alt);
      if (!handle) continue;

      // Exact handleized match (e.g. '60-inches-tall-headboard').
      if (handle === target) return thumb;

      // Fuzzy fallback: a headboard-looking alt that contains the size number.
      if (
        sizeNumber &&
        /headboard|tall|inch|height/.test(handle) &&
        handle.indexOf(sizeNumber) !== -1
      ) {
        return thumb;
      }
    }
    return null;
  }

  function setMainImage(thumb) {
    var main = document.querySelector('[data-gallery-main-image]');
    if (!main) return;

    document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      var isActive = t === thumb;
      t.classList.toggle('is-active', isActive);
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    var src = thumb.getAttribute('data-image-src');
    var srcset = thumb.getAttribute('data-image-srcset');
    var alt = thumb.getAttribute('data-image-alt') || '';

    if (src) {
      main.classList.add('is-loading');
      main.src = src;
      if (srcset) main.srcset = srcset;
      main.alt = alt;

      var finish = function () {
        main.classList.remove('is-loading');
        main.removeEventListener('load', finish);
        main.removeEventListener('error', finish);
      };
      main.addEventListener('load', finish);
      main.addEventListener('error', finish);
    }
  }

  var lastWasHeadboard = false;
  var lastHeadboardValue = '';
  var scheduled = false;

  function activate() {
    scheduled = false;
    if (!lastWasHeadboard) return;

    var sizeValue = lastHeadboardValue || getSelectedHeadboardValue();
    var thumb = findHeadboardThumb(sizeValue);
    if (!thumb) return;

    // Make the headboard thumbnail visible, then show it as the main image.
    thumb.hidden = false;
    setMainImage(thumb);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    // Run after the gallery controller's own variant:change handling.
    setTimeout(activate, 60);
    setTimeout(activate, 220);
  }

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;

    var headboardBtn = event.target.closest('.headboard-opt');
    if (headboardBtn) {
      lastWasHeadboard = true;
      lastHeadboardValue = headboardBtn.getAttribute('data-option-value') || '';
      schedule();
      return;
    }

    // Selecting any other option (color/size/storage) hands the gallery back
    // to the normal behavior.
    if (event.target.closest('.color-opt, .opt-card, .storage-opt, [data-color-option]')) {
      lastWasHeadboard = false;
    }
  }, true);

  document.addEventListener('variant:change', schedule);
})();
